// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
//import { createApp } from 'vue'
import { createVuetify } from 'vuetify'

const alpaka_theme_light = {
  dark: false,
  colors: {
    background: '#ffffff',
    primary: '#0094CE',
    secondary: '#CFA900',
  },
}

const alpaka_theme_dark = {
  dark: true,
  colors: {
    background: '#000000',
    primary: '#3d513d',
    secondary: '#513d51',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'alpaka_theme_light',
    themes: {
      alpaka_theme_light,
      alpaka_theme_dark,
    },
  },
  display: {
    mobileBreakpoint: 'sm',
  },
})

